<template>
  <div class="my-server" v-show="isShowSubmitBtn">
    <van-skeleton avatar title :row="5" :loading="!isShowSubmitBtn">
      <img v-if="formList.isPic == 1 && formList.quesPic" v-lazy="formList.quesPic" alt="" />
      <img v-else-if="formList.isPic == 1" src="../../assets/images/header-img.png" alt="" />
    </van-skeleton>
    <van-skeleton :row="2" :loading="!isShowSubmitBtn">
      <div class="header-text">
        <h3>
          <span v-show="formList.subName">【{{ formList.subName }}】</span>{{ formList.quesTitle }}
        </h3>
        <p style="white-space: pre-wrap">{{ formList.quesDes }}</p>
      </div>
    </van-skeleton>
    <div class="content">
      <van-form @submit="closureSubmit">
        <!-- onSubmit -->
        <div v-for="(item, index) in formList.weQuesInfoVos" :key="item.id" :class="[item.type == 1 || item.type == 2 ? ' no-field' : '', 'question-item']">
          <div class="ques-label">
            {{ index + 1 }}.{{ item.title }}
            <span v-show="item.isMust == 1">*</span>
          </div>
          <!-- 单行简答题 -->
          <div v-if="item.type == 3 && item.isValueType !== 4 && item.isValueType !== 5 && item.isValueType !== 7">
            <van-field v-model="item.answer" :placeholder="item.defaultVlaue || '请输入'" :rules="[{ required: item.isMust == 1, message: '请输入' }]"></van-field>
          </div>

          <!-- 单行简答题 -->
          <div v-if="item.type == 8">
            <van-field v-model="item.answer" :placeholder="item.defaultVlaue || '请输入'" :rules="[{ required: item.isMust == 1, message: '请输入' }]"></van-field>
          </div>
          <!-- 多行简答题 -->
          <van-field
            v-if="item.type == 4"
            v-model="item.answer"
            type="textarea"
            :placeholder="item.defaultVlaue || '请输入'"
            :rules="[{ required: item.isMust == 1, message: '请输入' }]"
          ></van-field>
          <!-- 电话 -->
          <div>
            <van-field
              v-if="item.type == 5"
              v-model="item.answer"
              placeholder="请输入"
              maxlength="11"
              type="number"
              :rules="
                item.isMust == 1
                  ? [
                      { required: true, message: '请输入手机号' },
                      { validator, message: '请输入正确的手机号' },
                    ]
                  : [{ required: false }]
              "
            />
            <div v-if="item.type == 5 && item.isValueType == 3" class="phone-flex">
              <van-field v-model="item.code" type="number" maxlength="6" placeholder="请输入" :rules="[{ required: item.isMust == 1, message: '' }]" />
              <van-button :disabled="btnText !== '获取验证码'" type="info" native-type="button" @click="getPhoneCode(item.answer)">{{ btnText }}</van-button>
            </div>
          </div>
          <!-- 多选框 -->
          <van-field v-if="item.type == 2" name="switch" :rules="[{ required: item.isMust == 1, message: '请选择' }]">
            <template #input>
              <van-checkbox-group v-model="item.quesOptionIds" @change="checkboxChange($event, item.weQuesOptionVos, index)">
                <van-checkbox v-for="ques in item.weQuesOptionVos" :key="ques.id" :name="ques.id" shape="square">{{ ques.quesValue }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <!-- 单选框 -->
          <van-field v-if="item.type == 1" name="radio" :rules="[{ required: item.isMust == 1, message: '请选择' }]">
            <template #input>
              <van-radio-group v-model="item.quesOptionIds" @change="singleChange($event, item.weQuesOptionVos, index)">
                <van-radio v-for="ques in item.weQuesOptionVos" :key="ques.id" :name="ques.id">{{ ques.quesValue }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 视频资料 -->
          <div v-if="item.type == 6">
            <el-select v-model="item.subResId" placeholder="请选择" @focus="focusWidth">
              <el-option v-for="item in item.weQuesZsOptions" :key="item.zsId" :label="item.zsTitle" :value="item.zsId" :style="{ width: setOptionWidth }" />
            </el-select>
            <p v-if="!item.subResId && firsTimeShow" class="red-tips">请选择要开通的视频资料</p>
          </div>
          <!-- 毕业日期 -->
          <div v-if="item.type == 3 && item.isValueType == 7">
            <el-select v-model="item.answer" placeholder="请选择" @focus="focusWidth">
              <el-option v-for="item in endYearOptions" :key="item" :label="item + '年'" :value="item" :style="{ width: setOptionWidth }" />
            </el-select>
          </div>
          <!-- 单个日期 -->
          <div v-if="item.type == 3 && item.isValueType == 4">
            <el-date-picker v-model="item.answer" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
            <p v-if="item.isMust == 1 && item.answer == null && firsTimeShow" class="red-tips">时间必填</p>
          </div>
          <!-- 日期间隔 -->
          <div v-if="item.type == 3 && item.isValueType == 5">
            <div class="time-center">
              <el-date-picker
                v-model="item.startTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
                @change="timeChange($event, index, 'startTime')"
              />
              <el-date-picker
                v-model="item.endTime"
                type="date"
                placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="timeChange($event, index, 'endTime')"
              />
            </div>
            <p v-if="item.isMust == 1 && (item.startTime == null || item.endTime == null) && firsTimeShow" class="red-tips">时间必填</p>
          </div>
        </div>
        <van-button @click="firsTimeShow = true" :disabled="overiewDisabled == 1 ? true : false" type="primary" native-type="submit" class="submit-btn">确认提交</van-button>
      </van-form>
    </div>
  </div>
</template>
<script>
import { Notify, Toast } from "vant";
import { getUrlParam, formatDate, timeClick } from "@/utils/public.js";
import { ruleTime } from "./js/index";
import { officialinfo, wequesrecordsave, wequesanswersendSms, wequesinfo, answersave, answerisSubmit, answerisAuth } from "@/server/api.js";
import axios from "axios";
let APPID = window.document.domain === "xyqw.xinyuanhulian.com" ? "ww29a0b9ab8da601a6" : "wx0de53b5d3a717289";
export default {
  data() {
    return {
      openid: "",
      APPID: APPID,
      firsTimeShow: false,
      btnText: "获取验证码",
      startTime: "",
      endTime: "",
      userInfo: {},
      quesId: "",
      userId: null,
      videOptions: [],
      endYearOptions: [],
      subResId: "",
      addr: "",
      isSubmitId: "",
      setOptionWidth: null,
      overiewDisabled: "",
      formList: [],
      checkedLabel: "",
      isAuth: "",
      isShowSubmitBtn: false,
    };
  },
  mounted() {
    document.title = "问卷调查";
    this.getCode();
    // this.infoQueste();
  },

  methods: {
    getCode() {
      const code = getUrlParam("code");
      let state = getUrlParam("state");
      const local = window.location.href;
      if (code == null || code === "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
      } else {
        this.quesId = getUrlParam("quesId");
        this.userId = getUrlParam("userId");
        this.overiewDisabled = getUrlParam("overiewDisabled");
        this.getOpenId(code, state); //获取信息
      }
    },
    authHandle() {
      answerisAuth({
        userId: this.userId,
        id: this.isSubmitId || "",
        openid: this.userInfo.openid || "",
        stuName: this.userInfo.nickname || "",
        headImg: this.userInfo.headimgurl || "",
        unionid: this.userInfo.unionid || "",
        isAuth: 2,
        quesId: this.quesId,
      }).then((res) => {
        console.log(res);
        if (res.code !== "200") return Toast.fail(res.msg);
        this.isAuth = res.data.id;
      });
    },
    // 获取信息
    getOpenId(code, state) {
      officialinfo({ code, state }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.userInfo = res.data;
        let time = new Date().getFullYear();
        for (let i = time - 20; i <= time + 10; i++) {
          this.endYearOptions.push(i);
        }
        this.isSubmit(); // 是否提交过
        this.officialDetail(1); // 记录
        this.infoQueste();
      });
    },
    // 获取试卷
    async infoQueste() {
      let res = await wequesinfo({ id: this.quesId });
      if (res.code !== "200") return Toast.fail(res.msg);
      this.formList = res.data;
      this.getIP();
      // console.log(res.weQuesInfoVos);
    },
    // 记录
    async officialDetail(type) {
      let params = {
        quesId: this.quesId,
        source: this.userId ? 2 : 1,
        type, //1点击，2提交
        unionid: this.userInfo.unionid,
        userId: this.userId || null,
      };
      let res = await wequesrecordsave(params);
      if (res.code !== "200") Toast.fail(res.msg);
    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
    // 多选找选中的值
    checkboxChange(value, options, index) {
      let answer = "";
      let tagsIds = "";
      let quality = "";
      options.filter(function (v) {
        if (value.indexOf(v.id) > -1) {
          answer += v.quesValue + ";";
          tagsIds += v.tagsIds == "" ? "" : v.tagsIds + ";";
          // isRremarks += v.isRremarks == "" ? "" : v.isRremarks + ";";
          quality += v.quality == "" ? "" : v.quality + ";";
        }
      });
      let nameArr = { answer, tagsIds, quality };
      for (let v in nameArr) {
        this.formList.weQuesInfoVos[index][v] = nameArr[v];
      }
    },
    // 单选找选中的值
    singleChange(value, options, index) {
      let checkObj = options.find((item) => {
        return item.id == value;
      });
      let nameArr = {
        answer: "quesValue",
        tagsIds: "tagsIds",
        // isRremarks: "isRremarks",
        quality: "quality",
      };
      for (let v in nameArr) {
        this.formList.weQuesInfoVos[index][v] = checkObj[nameArr[v]];
      }
    },
    timeChange(val, index, name) {
      let questionObj = this.formList.weQuesInfoVos[index];
      let flag = ruleTime(val, index, name, questionObj);
      if (flag) {
        questionObj[name] = formatDate(val);
      } else {
        questionObj[name] = "";
      }
    },
    // 手机验证码
    async getPhoneCode(phone) {
      let timer = null;
      let countDown = 60;
      if (phone == "" || !/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) return Notify({ type: "danger", message: "请输入正确的手机号" });
      if (this.btnText !== "获取验证码") return;
      clearInterval(timer);
      let res = await wequesanswersendSms({ tel: phone });
      if (res.code == "200") {
        Notify({ type: "success", message: res.msg });
        timer = setInterval(() => {
          countDown--;
          this.btnText = countDown + "s后获取";
          if (countDown <= 0) {
            clearInterval(timer);
            countDown = 60;
            this.btnText = "获取验证码";
          }
        }, 1000);
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },
    focusWidth(e) {
      this.setOptionWidth = e.srcElement.offsetWidth + "px";
    },
    isSubmit() {
      answerisSubmit({
        quesId: this.quesId || "",
        unionid: this.userInfo.unionid || "",
      }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        if (res.data.isSubmit == 1) {
          this.isShowSubmitBtn = false;
          let phone = navigator.userAgent;
          if (res.data.extensionUrl && res.data.extensionUrl !== "") {
            if (phone.indexOf("Android") > -1 && phone.indexOf("Adr") > -1) {
              window.location.href = res.data.extensionUrl;
            } else {
              document.location.href = `${res.data.extensionUrl}?timestamp=` + Math.random();
            }
          } else {
            this.$router.push({
              path: "/pass",
              query: { already: true },
            });
          }
        } else {
          this.isShowSubmitBtn = true;
          this.isSubmitId = res.data?.id || "";
          this.authHandle();
        }
      });
    },
    videoChange(arr, id) {
      let flag = "";
      if (arr.length > 0) {
        flag = arr.find((v) => v.zsId == id).zsTitle;
      }
      return flag;
    },
    getIP() {
      this.addr = "";
      var instance = axios.create();
      delete instance.defaults.headers.common["Authorization"];
      instance.get("http://oa.1000phone.net/oa.php/Api/getIpAddr").then((res) => {
        if (res.data.code == 200) {
          this.addr = res.data.ip;
        }
      });
    },
    closureSubmit: timeClick(function () {
      this.onSubmit();
    }, 3000),

    onSubmit() {
      let params = {
        headImg: this.userInfo.headimgurl || "",
        openid: this.userInfo.openid || "",
        stuName: this.userInfo.nickname || "",
        quesId: this.quesId,
        userId: this.userId || null,
        source: this.userId ? 2 : 1,
        unionid: this.userInfo.unionid || "",
        quesType: this.formList.quesType,
        subResId: "",
        id: this.isAuth,
        addr: this.addr,
        isAuth: 3,
        graduateTime: "",
        weQuesAnswerInfoVos: [],
      };

      let answerArr = [];
      this.formList.weQuesInfoVos.map((v) => {
        let quesAnswer = {
          titlle: v.title,
          answer: v.answer || "",
          type: v.type,
          tagsIds: v.tagsIds,
          quesInfoId: v.id,
          isRremarks: v.isRremarks,
          quality: v.quality,
        };
        // 5: 手机号,3: 单行简答,4: 多行简答,2: 多选,1: 单选, 6: 视频
        if (v.type == 5) {
          params.phone = v.answer;
          params.code = v.code || "";
          params.isPhone = v.isValueType == 3 ? 1 : 2;
        } else if (v.type == 3 && v.isValueType == 5) {
          quesAnswer.answer = v.startTime + "/" + v.endTime;
        } else if (v.type == 5 && v.isValueType == 3) {
          quesAnswer.code = v.code || "";
        } else if (v.type == 2) {
          quesAnswer.quesOptionIds = v.quesOptionIds.join(";");
        } else if (v.type == 1) {
          quesAnswer.quesOptionIds = v.quesOptionIds;
        } else if (v.type == 3 && v.isValueType == 7) {
          params.graduateTime = v.answer;
        } else if (v.type == 6) {
          // quesAnswer.zsId = v.subResId;
          // quesAnswer.zsTitle = this.videoChange(v.weQuesZsOptions, v.subResId);
          params.subResId = v.subResId;
          quesAnswer.answer = v.subResId + ":" + this.videoChange(v.weQuesZsOptions, v.subResId);
          // this.checkedLabel
        }else if (v.type == 8) {
          params.qq = v.answer;
        }
        answerArr.push(quesAnswer);
      });
      params.weQuesAnswerInfoVos = answerArr;
      console.log(JSON.stringify(params));
      if (document.getElementsByClassName("red-tips").length <= 0) {
        answersave(params).then((res) => {
          if (res.code !== "200") return Toast.fail(res.msg);
          Toast.success("提交成功");
          this.officialDetail(2);
          if (res.data.extensionUrl && res.data.extensionUrl !== "") {
            window.location.href = res.data.extensionUrl;
          } else {
            this.$router.push({
              path: "/pass",
              query: { alreadys: false },
            });
          }
        });
      }
    },
  },
  destroyed() {
    this.userId = null;
  },
};
</script>
<style scoped lang="less">
@import "./css/index.less";
</style>
<style lang="less">
.my-server {
  .van-checkbox__label,
  .van-radio__label,
  .van-field__control {
    font-size: 26px;
  }
}
</style>
